import { useRef, useState } from "react"

const useObjectState = (initialValue) => {
  const valueRef = useRef(initialValue === true ? {} : initialValue)
  const [value, setValue] = useState(valueRef.current)
  const [setObjectValue, ] = useState(() => { return (key, newValue = undefined) => {
    if (key === true) {
      valueRef.current = {}
      setValue(valueRef.current)
    } else if (key === false) {
      valueRef.current = false
      setValue(valueRef.current)
    } else if (key instanceof Object) {
      valueRef.current = key
      setValue({ ...valueRef.current })
    } else {
      if (!valueRef.current) valueRef.current = {}
      valueRef.current[key] = newValue
      setValue({ ...valueRef.current })
    }
  }})
  return [value, setObjectValue]
}

export default useObjectState